import { useMutation } from "@tanstack/react-query";
import { loginWithTelegramAuthButton } from "../api/authApi";
import { useAuthStore } from "../store/authStore";
import { TelegramAuthData } from "@telegram-auth/react";
import { logger } from "@/shared/utils/logger";

export const useAuthByTelegramButton = () => {
  const setAccessToken = useAuthStore((state) => state.setAccessToken);

  return useMutation({
    mutationFn: (authBtnData: TelegramAuthData) =>
      loginWithTelegramAuthButton(authBtnData),
    onSuccess: (response) => {
      setAccessToken(response.accessToken);
      logger.info("User authenticated successfully.");
    },
  });
};
